import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { BRAND, NAV_LINKS, waLink } from "@/lib/brand";

const Footer = () => {
  return (
    <footer id="contato" className="bg-choco text-cream/80 pt-20 pb-8">
      <div className="mx-auto max-w-[1400px] px-5 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/logo_light.png" alt="Deco Sweet" className="h-24 w-auto object-contain mb-4" />
          <p className="text-sm text-cream/60 leading-relaxed max-w-xs">
            Confeitaria artesanal que transforma momentos especiais em memórias doces. Doces que encantam.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-xl text-cream mb-5">Menu</h4>
          <ul className="space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.label}><a href={l.href} className="hover:text-gold transition-colors" data-testid={`footer-nav-${l.label}`}>{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-cream mb-5">Atendimento</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={waLink()} className="flex items-center gap-3 hover:text-gold transition-colors"><Phone size={15} className="text-gold" /> {BRAND.phoneDisplay}</a></li>
            <li><a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors"><Instagram size={15} className="text-gold" /> {BRAND.instagram}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-gold transition-colors"><Mail size={15} className="text-gold" /> {BRAND.email}</a></li>
            <li className="flex items-center gap-3"><MapPin size={15} className="text-gold" /> {BRAND.location}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-cream mb-5">Vamos adoçar seu dia</h4>
          <p className="text-sm text-cream/60 mb-5">Chame no WhatsApp e faça sua encomenda com carinho.</p>
          <a href={waLink()} data-testid="footer-whatsapp"
            className="inline-flex items-center gap-2 rounded-full bg-gold text-choco px-6 py-3 text-xs font-semibold uppercase tracking-widest hover:bg-cream transition-colors">
            <MessageCircle size={16} /> Chamar no WhatsApp
          </a>
          <div className="flex gap-3 mt-6">
            <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-choco hover:border-gold transition-colors"><Instagram size={17} /></a>
            <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-choco hover:border-gold transition-colors"><Facebook size={17} /></a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 mt-14 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
        <p>© {new Date().getFullYear()} Deco Sweet — Todos os direitos reservados.</p>
        <a href="/admin/login" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Área do Administrador</a>
      </div>
    </footer>
  );
};

export default Footer;
